<template>
<div class="pmf-results-wrapper">
  <div class="site-name">
    <h2>{{site.name}}</h2>
  </div>

  <el-tabs v-model="stepData[stepDataKey].tabName">
    <el-tab-pane
      v-for="component in components"
      :key="component.name"
      :name="component.name"
      :label="component.label"
    />
  </el-tabs>

  <Component
    v-if="thisData && thisData.compareJSONStr"
    :is="thisData.tabName"
    :task-id="stepData.task.id"
    :data.sync="thisData[componentMap[thisData.tabName].dataKey]"
    :share-data="thisData.shareData"
    :condition="condition"
    :data-time-formatter="dataType.formatter"
    :sources="thisData.sources"
    :site="site"
  />
</div>
</template>

<script>
import loader from '../../../../../../utils/loader'
import BaseStep from '../BaseStep'

const stepDataKey = 'results'

const components = Object.values(loader.getByFileName(require.context('./../ResultComponents', true, /\.(vue)$/)))

export default {
  name: 'ResultStep',
  label: 'PMF结果',
  stepDataKey,
  extends: BaseStep,
  props: {
    isRun: {
      type: Boolean,
      default: true
    }
  },
  components: components.reduce((map, component) => {
    map[component.name] = component
    return map
  }, {}),
  computed: {
    baseRunConfig () {
      const {condition} = this

      return {
        id: condition.id,
        runCount: condition.runCount,
        sourceCount: condition.sourceCount
      }
    },
    thisData () {
      return this.stepData[stepDataKey]
    },
    stepDataKey: () => stepDataKey,
    components: () => components,
    componentMap: () => components.reduce((map, component) => {
      map[component.name] = component
      return map
    }, {})
  },
  methods: {
    baseRunConfigIsChanged (thisData) {
      const {condition} = this
      return thisData !== JSON.stringify({
        id: condition.id,
        runCount: condition.runCount,
        sourceCount: condition.sourceCount
      })
    }
  },
  created () {
    let {stepData, baseRunConfig} = this
    const thisData = stepData[stepDataKey]
    const compareJSONStr = JSON.stringify(baseRunConfig)

    if (thisData) {
      if (thisData.compareJSONStr === compareJSONStr) {
        return
      }
    }

    stepData[stepDataKey] = components.reduce((map, component) => {
      map[component.dataKey] = null
      return map
    }, {
      shareData: null,
      tabName: components[0].name,
      compareJSONStr: null,
      sources: Object.freeze([])
    })

    if (this.isRun) {
      this.changeLoadStatus(true)
      this.$api.PMFAnalysis.baseRun(baseRunConfig).then(data => new Promise((resolve, reject) => {
        const taskId = this.stepData.task.id
        return Promise.all([
          this.$api.PMFAnalysis.timeSource(taskId),
          this.$api.PMFAnalysis.factorSource(taskId),
          this.$api.PMFPollutantSource.getList({
            sourceType: this.sourceType
          })
        ]).then(resolve).catch(reject).finally(() => {
          stepData[stepDataKey].compareJSONStr = compareJSONStr
        })
      })).then(([timeSources, factorSources, sources]) => {
        stepData[stepDataKey].sources = Object.freeze(sources)
        stepData[stepDataKey].shareData = Object.freeze({
          timeSources: timeSources.map(timeSource => ({
            ...timeSource,
            contribution: timeSource.contribution === -99999 ? null : timeSource.contribution
          })),
          factorSources: factorSources.map(factorSource => ({
            ...factorSource,
            conc: factorSource.conc === -99999 ? null : factorSource.conc,
            percent: factorSource.pecent === -99999 ? null : Number((factorSource.pecent * 100).toFixed(2))
          })).sort((a, b) => a.factorId.localeCompare(b.factorId) || a.name.localeCompare(b.name))
        })
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    } else {
      this.changeLoadStatus(true)
      const taskId = this.stepData.task.id
      return Promise.all([
        this.$api.PMFAnalysis.timeSource(taskId),
        this.$api.PMFAnalysis.factorSource(taskId),
        this.$api.PMFPollutantSource.getList({
          sourceType: this.sourceType
        })
      ]).then(([timeSources, factorSources, sources]) => {
        stepData[stepDataKey].sources = Object.freeze(sources)
        stepData[stepDataKey].shareData = Object.freeze({
          timeSources: timeSources.map(timeSource => ({
            ...timeSource,
            contribution: timeSource.contribution === -99999 ? null : timeSource.contribution
          })),
          factorSources: factorSources.map(factorSource => ({
            ...factorSource,
            conc: factorSource.conc === -99999 ? null : factorSource.conc,
            percent: factorSource.pecent === -99999 ? null : Number((factorSource.pecent * 100).toFixed(2))
          })).sort((a, b) => a.factorId.localeCompare(b.factorId) || a.name.localeCompare(b.name))
        })
      }).catch(console.error).finally(() => {
        stepData[stepDataKey].compareJSONStr = compareJSONStr
        this.changeLoadStatus(false)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.pmf-results-wrapper {
  display: grid;
  grid-template-rows: max-content max-content auto;

  > * {
    min: {
      width: 0;
      height: 0;
    }
  }

  > .site-name {
    > * {
      margin: 0;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/11PMF-Analysis/01PM/01Run/steps/03ResultStep.vue